<script setup lang="ts">
// ================================
// IMPORTS
// ================================
import { computed } from "vue"
import { useI18n } from "vue-i18n"

// ================================
// INTERNATIONALIZATION
// ================================
const { t } = useI18n({
    messages: {
        fr: {
            alarm: {
                actionTooltipEdit:
                    "Modifier les consignes et limites du profil d’alarme.",
                actionTooltipImportBuilding:
                    "Importer un profil d'alarme depuis un autre bâtiment.",
                actionTooltipImportSource:
                    "Importer un profil d'alarme depuis une autre source de donnée.",
                actionTooltipAutoGenerate:
                    "Générer automatiquement le profil d'alarme à partir de vos données historiques.",
                actionTooltipDelete:
                    "Supprimer le profil d'alarme pour cette variable.",
            },
        },
    },
})

// ================================
// PROPS & EMITS
// ================================
const props = defineProps<{
    /** Contexte d’alarme : bâtiment ou source de données. */
    type: "building" | "source"
}>()

// ================================
// COMPUTED
// ================================
/** Texte du tooltip du bouton d’import selon le contexte bâtiment / source. */
const getActionTooltipImport = computed(() =>
    props.type === "building"
        ? t("alarm.actionTooltipImportBuilding")
        : t("alarm.actionTooltipImportSource")
)

const emit = defineEmits<{
    edit: []
    delete: []
    import: []
    "auto-generate": []
}>()
</script>

<template>
    <!-- ================================ -->
    <!-- Actions ligne variable alarme -->
    <!-- ================================ -->
    <div class="flex flex-wrap gap-2">
        <BaseButton
            v-tooltip.top="t('alarm.actionTooltipEdit')"
            text
            rounded
            icon="pi pi-pencil"
            :aria-label="t('alarm.actionTooltipEdit')"
            @click="emit('edit')"
        />
        <BaseButton
            v-tooltip.top="getActionTooltipImport"
            text
            rounded
            icon="pi pi-upload"
            :aria-label="getActionTooltipImport"
            @click="emit('import')"
        />
        <BaseButton
            v-tooltip.top="t('alarm.actionTooltipAutoGenerate')"
            text
            rounded
            icon="pi pi-bolt"
            :aria-label="t('alarm.actionTooltipAutoGenerate')"
            @click="emit('auto-generate')"
        />
        <BaseButton
            v-tooltip.top="t('alarm.actionTooltipDelete')"
            rounded
            text
            severity="danger"
            icon="pi pi-trash"
            :aria-label="t('alarm.actionTooltipDelete')"
            @click="emit('delete')"
        />
    </div>
</template>
